import React, { FC, MouseEventHandler } from 'react';

import NavbarLink from './NavbarLink';

export interface NavbarItemInterface {
  icon?: string;
  label: string;
  onClick?: MouseEventHandler;
  path: string;
}

const NavbarItem: FC<NavbarItemInterface> = (itemProps) => {
  const { icon, label, onClick, path } = itemProps;

  return <NavbarLink icon={icon} label={label} path={path} title={label} onClick={onClick} />;
};

export default NavbarItem;
